theme.CartDrawerActions = (function() {
  var clicksBound = false;

  function live(id) {
    return document.getElementById(id);
  }

  function onDrawerClick(event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return;

    var actionOverlay = document.querySelector('.cart_action_drawer_overlay');
    var cartNote = live('cart_note_drawer');
    var shippingCalc = live('shipping_drawer');
    var item = target.closest('.cart_notification_action_button');
    if (item) {
      if (item.dataset.drawer === 'note') {
        if (cartNote) cartNote.classList.add('active');
        if (actionOverlay) actionOverlay.classList.add('active');
      } else {
        if (shippingCalc) shippingCalc.classList.add('active');
        if (actionOverlay) actionOverlay.classList.add('active');
      }
      return;
    }

    item = target.closest('.button__cancel');
    if (item && item.closest('.action_drawer_footer')) {
      if (item.dataset.action === 'note') {
        if (cartNote) cartNote.classList.remove('active');
        if (actionOverlay) actionOverlay.classList.remove('active');
      } else {
        if (shippingCalc) shippingCalc.classList.remove('active');
        if (actionOverlay) actionOverlay.classList.remove('active');
      }
      return;
    }

    item = target.closest('.button__save');
    if (!item || !item.closest('.action_drawer_footer')) return;

    if (item.dataset.action === 'note') {
      var cartNoteData = live('cartNote');
      if (!cartNoteData) return;
      var noteUpdate = cartNoteData.value;
      item.classList.add('loading');
      var body = JSON.stringify({
        note: noteUpdate
      });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.json();
        })
        .then((state) => {
          if (cartNote) cartNote.classList.remove('active');
          if (actionOverlay) actionOverlay.classList.remove('active');
          item.classList.remove('loading');
        })
        .catch((e) => {
          console.error(e);
        });
      return;
    }

    if (item.dataset.action === 'shipping') {
      var shippingRatePackage = document.querySelector('.shipping_rate_package');
      var shippingAddressWrapper = document.querySelector('.shipping_rate_message');
      var shippingAddressCount = document.querySelector('.shipping_address_count');
      var shippingCountry = live('AddressCountry_Shipping');
      var countryState = live('AddressProvince_shipping');
      var shippingCountryZip = live('ShippingAddressZip');

      if (shippingRatePackage) shippingRatePackage.innerHTML = '';
      if (shippingCountry && shippingCountry.value !== '---') {
        item.classList.add('loading');
        fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${shippingCountryZip && shippingCountryZip.value}&shipping_address%5Bcountry%5D=${shippingCountry.value}&shipping_address%5Bprovince%5D=${countryState && countryState.value}`)
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else {
              throw `${window.shipping.wrong_message}`;
            }
          })
          .then((response) => {
            item.classList.remove('loading');

            if (shippingAddressWrapper) shippingAddressWrapper.classList.remove('no-js-inline');
            if (shippingAddressCount) shippingAddressCount.innerText = `${response.shipping_rates.length}`
            response.shipping_rates.map((rate) => {
              let text = document.createElement('P');
              text.setAttribute('class', 'mb-0');
              text.innerText = `${rate.name}: ${shopCurrencySymbol}${rate.price}`
              if (shippingRatePackage) shippingRatePackage.appendChild(text);
            })
          })
          .catch((e) => {
            item.classList.remove('loading');
            if (shippingAddressWrapper) shippingAddressWrapper.classList.add('no-js-inline');
            if (shippingRatePackage) shippingRatePackage.innerHTML = `<p class="error mt-15">${e}</p>`;
          });
      } else if (shippingAddressWrapper && shippingRatePackage) {
        shippingAddressWrapper.classList.add('no-js-inline');
        shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping.country_label}</p>`;
      }
    }
  }

  function cartActions(){
    var cartNoteData = live('cartNote'),
      shippingCountry = live('AddressCountry_Shipping'),
      countryState = live('AddressProvince_shipping');

    // #cartNote only renders while the cart-note setting is on, and it is off,
    // so this fetch ran on every page and threw writing to null.
    if (cartNoteData) fetch('/cart.js')
      .then(response => response.json())
      .then(json => {
        if (cartNoteData) cartNoteData.value = json.note;
      })
      .catch(err => console.log(err));

    // Header section reloads used to stack a new listener on every button.
    // One document-level delegate survives those remounts and is the only
    // theme listener on the note / gift-message save path.
    if (!clicksBound && document.addEventListener) {
      clicksBound = true;
      document.addEventListener('click', onDrawerClick);
    }

    if(shippingCountry && countryState){
      if (Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector('AddressCountry_Shipping', 'AddressProvince_shipping', {
          hideElement: 'AddressProvinceContainerNewShiping'
        });
      }
    }
  }
  return cartActions;
})();
